module.exports = __webpack_public_path__ + "img/vi.b6a3ceba.svg";